import { exposeFunction } from "@/utils/pages";



export default async function entrypoint() {
    exposeFunction("ical_download", (event_name: string, event_start: string, event_end: string, event_location: string, event_url: string) => {
            var now = new Date();
            var ics_lines = [
                "BEGIN:VCALENDAR",
                "VERSION:2.0",
                "BEGIN:VEVENT",
                "UID:event-"+now.getTime(),
                "DTSTART:"+event_start,
                "DTEND:"+event_end,
                "DESCRIPTION:"+event_url,
                "LOCATION:"+event_location,
                "SUMMARY:"+event_name,
                "END:VEVENT",
                "END:VCALENDAR"
            ];

            const url = URL.createObjectURL(new Blob([ics_lines.join('\r\n')], {type: 'text/calendar'}));

            let save: HTMLAnchorElement|null = null;
            try {
                save = document.createElement('a');
                save.href = url;
                save.target = '_blank';
                save.download = event_name || 'unknown';
            
                var evt = new MouseEvent('click', {
                    'view': window,
                    'bubbles': true,
                    'cancelable': false
                });
                save.dispatchEvent(evt);
            } catch(e) {
                window.reportError(e);
            } finally {
                if (!!save) URL.revokeObjectURL(save.href);
            }
    });
}
